/* eslint-disable */
import { useState, useEffect, useRef, useMemo } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

// Import CKEditor here (both required).
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import JoditEditor from "jodit-react";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  postData,
  getData,
  putData,
  uploadSingleFile,
  deleteData,
} from "utils/Gateway";

import languageOptions from "data/Prod/LanguageOptions.json";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";
import { assetImages } from "constants";
import { courseDetailsHeaderObject } from "helper/CourseHelper/CourseHelper";
import { reactSelectStyle } from "Config/Config";
import AfterSaveCourseModal from "./Modal/AfterSaveCourseModal";
import { getAllCategories } from "helper/CategoryHelper/CategoryHelper";
import { ecosystemSlug } from "Config/Config";
import UploadContentModal from "components/Common/Modal/UploadContentModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";

const CourseDetailBody = () => {
  const todayValue = new Date().toISOString().split("T")[0];
  const params = useParams();
  const history = useHistory();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");
  const { t } = useTranslation(); //for translation
  const editor = useRef(null);

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: t("Course"), link: "/admin/courses" },
    { title: t("Course Details") },
  ];

  // common header object
  const commonHeaderObject = courseDetailsHeaderObject(params.id, t);

  const imageFileInputRef = useRef(null);

  const [isDetailsLoading, setIsDetailsLoading] = useState(false);

  const [parentCourseInput, setparentCourseInput] = useState("");
  const [parentCourseList, setparentCourseList] = useState([]);
  const [categoryList, setcategoryList] = useState([]);
  const [skillList, setskillList] = useState([]);
  const [title, settitle] = useState("");
  const [code, setcode] = useState("");
  const [languageValue, setlanguageValue] = useState(null);
  const [selectedLanguage, setselectedLanguage] = useState("");
  const [parentValue, setparentValue] = useState(null);
  const [selectedParentId, setselectedParentId] = useState(null);
  const [summary, setsummary] = useState("");
  const [details, setdetails] = useState("");
  const [categoryValue, setcategoryValue] = useState(null);
  const [selectedCategories, setselectedCategories] = useState([]);
  const [skillValue, setskillValue] = useState(null);
  const [selectedSkills, setselectedSkills] = useState([]);
  const [uploadedFiles, setuploadedFiles] = useState([]);
  const [uploadedFileIds, setuploadedFileIds] = useState([]);
  const [authorsBio, setauthorsBio] = useState("");
  const [joinMessage, setjoinMessage] = useState("");
  const [thanksMessage, setthanksMessage] = useState("");
  const [selectedUploadId, setSelectedUploadId] = useState(null);
  const [uploadedPreviewImage, setUploadedPreviewImage] = useState("");
  const [uploadedImageId, setUploadedImageId] = useState(null); // use state for uploaded image id
  const [isUploading, setIsUploading] = useState(false);
  const [autoAccept, setautoAccept] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [savedCourseId, setSavedCourseId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [contetnIdForDelete, setcontetnIdForDelete] = useState(null);
  const [contentIndexForDelete, setcontentIndexForDelete] = useState(null);

  //* alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  const editorCustomConfig = {
    readonly: false,
    placeholder: "",
    height: 300,
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();

            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1];
            const newFileName = `image-${timestamp}.${fileExtension}`;

            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              const requestUrl =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                ``;

              const response = await uploadSingleFile(requestUrl, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  editorInstance.value = newContent;
                  setdetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    statusbar: false,
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
      "add-new-line",
    ],
  };

  const editorConfig = useMemo(() => editorCustomConfig, []);

  const validateForm = () => {
    const newErrors = {};

    if (!code.trim()) {
      newErrors.code = t(
        "Please enter a unique code for the course (e.g., CS101).",
      );
    }
    if (!title.trim()) {
      newErrors.title = t("A course title is required. Please enter one.");
    }
    if (selectedCategories.length === 0) {
      newErrors.selectedCategories = t(
        "Please select at least one category for this course.",
      );
    }
    if (selectedSkills.length === 0) {
      newErrors.selectedSkills = t(
        "Please tag at least one skill that this course teaches.",
      );
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get all parent course
  const getAllParentCourseList = async () => {
    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_COURSE_LIST_FOR_OPTIONS +
        `?coursestring=${parentCourseInput}&isparent=true`;

      const response = await getData(requestURL);

      if (response.status) {
        setparentCourseList(response.data);
      } else {
        setShowAlert(true);
        setAlertMessage("error");
        setAlertMessage(response.message);
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for get all category
  const getAllCategoryList = async () => {
    try {
      const parentSlug = "COURSE";
      const response = await getAllCategories(ecosystemSlug, parentSlug);
      if (response) {
        setcategoryList(response);
      } else {
        setShowAlert(true);
        setAlertMessage("error");
        setAlertMessage(response.message);
      }
    } catch (error) {
      console.log(error.message);
      setShowAlert(true);
      setAlertMessage("error");
      setAlertMessage(error.message);
    }
  };

  //get all skills
  const getAllSkillList = async () => {
    try {
      const parentSlug = "skills";
      const response = await getAllCategories(ecosystemSlug, parentSlug);
      if (response) {
        setskillList(response);
      } else {
        setShowAlert(true);
        setAlertMessage("error");
        setAlertMessage(response.message);
      }
    } catch (error) {
      console.log(error.message);
      setShowAlert(true);
      setAlertMessage("error");
      setAlertMessage(error.message);
    }
  };

  //function for select language
  const languaSelectionHandler = (val) => {
    if (val) {
      setlanguageValue(val);
      setselectedLanguage(val.value);
    } else {
      setlanguageValue(null);
      setselectedLanguage("");
    }
  };

  //function for select parent course
  const parentCourseSelectionHandler = (val) => {
    if (val) {
      setparentValue(val);
      setselectedParentId(val.value);
    } else {
      setparentValue(null);
      setselectedParentId(null);
      setparentCourseInput("");
      setparentCourseList([]);
    }
  };

  //function for select category
  const categorySelectionHandler = (val) => {
    if (val) {
      setcategoryValue(val);
      setselectedCategories(val.map((item) => item.value));
    } else {
      setcategoryValue(null);
      setselectedCategories([]);
    }
  };

  //function for select skills
  const skillSelectionHandler = (val) => {
    if (val) {
      setskillValue(val);
      setselectedSkills(val.map((item) => item.value));
    } else {
      setskillValue(null);
      setselectedSkills([]);
    }
  };

  //function for open image imput
  const openImageFileInput = () => {
    imageFileInputRef.current.click();
  };

  //function for image upload
  const imageUploadHandler = async (imageFile) => {
    const file = imageFile[0];

    setIsUploading(true);

    try {
      const requestUrl =
        url.API_BASE_URL + url.API_SINGLE_FILE_UPLOAD;
      const response = await uploadSingleFile(requestUrl, file);

      console.log("upload response-------->", response);

      if (response.status) {
        setIsUploading(false);
        setUploadedPreviewImage(response.data.path);
        setUploadedImageId(response.data._id);
        resetUploadedImageFile();
      } else {
        setShowAlert(true);
        setAlertMessage("error");
        setAlertMessage(response.message);
      }
    } catch (error) {
      console.error(error.message);
      setShowAlert(true);
      setAlertMessage("error");
      setAlertMessage(error.message);
    }
  };

  //function for close image file
  const closeEventImageFileHandler = () => {
    setUploadedPreviewImage("");
    setUploadedImageId(null);
    resetUploadedImageFile();
  };

  // function for clear file value
  const resetUploadedImageFile = () => {
    const file = document.getElementById("uploadedCourseImageFile");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  //function for delete content
  const deleteContentHandler = async () => {
    if (contentIndexForDelete && contetnIdForDelete) {
      try {
        setIsDeleting(true);
        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_CONTENT +
          `/${contetnIdForDelete}`;

        const response = await deleteData(requestURL);

        setIsDeleting(false);

        if (response.status) {
          const updatedFileids = [...uploadedFileIds];
          const updateFiles = [...uploadedFiles];

          updatedFileids.splice(contentIndexForDelete, 1);
          updateFiles.splice(contentIndexForDelete, 1);

          setuploadedFileIds(updatedFileids);
          setuploadedFiles(updateFiles);

          setcontentIndexForDelete(null);
          setcontetnIdForDelete(null);
        }
      } catch (error) {
        console.log(error.message);
      }
    } else {
      //alert notification
    }
  };

  //get cuourse details
  const getCourseDetails = async () => {
    try {
      setIsDetailsLoading(true);
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_COURSE_DETAILS +
        `/${params.id}`;

      const response = await getData(requestURL);

      console.log(response);

      if (response.status) {
        if (response.data.parentcoursevalue) {
          parentCourseSelectionHandler(response.data.parentcoursevalue);
        }
        setcode(response.data.code);
        settitle(response.data.title);
        setsummary(response.data.summary);
        setdetails(response.data.description);
        setauthorsBio(response.data.authorsbio);
        setjoinMessage(response.data.joiningmessage);
        setthanksMessage(response.data.thanksmessage);
        //set language
        for (let languageData of languageOptions) {
          if (languageData.value === response.data.language) {
            languaSelectionHandler(languageData);
          }
        }
        categorySelectionHandler(response.data.categoryvalues);
        skillSelectionHandler(response.data.skillvalues);
        setuploadedFileIds(response.data?.uploadcontentids);
        setuploadedFiles(response.data?.uploadcontentlist);
        setUploadedImageId(response.data?.courselogoid);
        setUploadedPreviewImage(response.data?.courselogopath);
        //assing auto accept
        setautoAccept(response.data?.autoapproval);

        setShowAlert(true);
        setMessageType("success");
        setAlertMessage(response.message);
      } else {
        setShowAlert(true);
        setAlertMessage("error");
        setAlertMessage(response.message);
      }
    } catch (error) {
      console.log(error.message);
      setShowAlert(true);
      setAlertMessage("error");
      setAlertMessage(error.message);
    } finally {
      setIsDetailsLoading(false);
    }
  };

  //function for save course
  const saveCourseHandler = async () => {
    if (validateForm()) {
      setErrorMessage(""); // Clear general error message if validation passes
      try {
        setIsSaving(true);

        let courseData = {
          code,
          parentid: selectedParentId,
          companyid: null,
          title,
          summary: summary,
          description: details,
          language: selectedLanguage,
          categories: selectedCategories,
          skills: selectedSkills,
          uploads: uploadedFileIds,
          authorsbio: authorsBio,
          joiningmessage: joinMessage,
          thanksmessage: thanksMessage,
          logoid: uploadedImageId,
          autoapproval: autoAccept,
        };

        let requestURL = url.API_BASE_URL;

        let response = {};

        if (params.id) {
          requestURL += url.API_UPDATE_COURSE + `/${params.id}`;
          response = await putData(requestURL, courseData);
        } else {
          courseData.createddate = todayValue;
          requestURL += url.API_ADD_NEW_COURSE;
          response = await postData(requestURL, courseData);
        }

        setIsSaving(false);

        if (response.status) {
          setSavedCourseId(response.data._id);
          setShowAlert(true);
          setMessageType("success");
          setAlertMessage(response.message);

          const bootstrapModal = new bootstrap.Modal(
            document.getElementById("saveCourse"),
          );

          bootstrapModal.show();
        } else {
          setShowAlert(true);
          setMessageType("error");
          setAlertMessage(response.message);
        }
      } catch (error) {
        console.log(error.message);
        setShowAlert(true);
        setMessageType("error");
        setAlertMessage(error.message);
      }
    } else {
      window.scrollTo(0, 0);
      setErrorMessage(
        t("Please correct the errors highlighted above before saving."),
      );
    }
  };

  const afterSaveCourseModalClose = (saveType = "list") => {
    if (saveType == "list") {
      history.push("/admin/courses");
    } else {
      if (params.id) {
        history.push(`/admin/course/save/${params.id}`);
      } else {
        history.push(`/admin/course/save/${savedCourseId}`);
      }
    }
  };

  // --- on alert close function ---
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  // Custom styles for category select input
  const categoryCustomStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.selectedCategories ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.selectedCategories ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  // Custom styles for skills select input
  const skillCustomStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errors.selectedSkills ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.selectedSkills ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.875rem",
      color: "#6c757d",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: "0.875rem",
    }),
  };

  useEffect(() => {
    if (params.id) {
      getCourseDetails();
    }
  }, [params.id]);

  useEffect(() => {
    getAllCategoryList();
    getAllSkillList();
  }, []);

  useEffect(() => {
    if (parentCourseInput.length > 1) {
      getAllParentCourseList();
    }
  }, [parentCourseInput]);

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_COURSE")
  ) {
    return (
      <div id="content_wrapper">
        <section className="event-details-wrapper bg-white pb-5">
          {/* ---- common header ---- */}
          {params.id && (
            <TabsHeader
              commonHeaderObject={commonHeaderObject}
              activeOption={t("Course Details")}
            />
          )}

          <div className="container-fluid px-lg-5 pt-4 pt-md-0">
            {/* ---- bread crumb ------- */}
            <BreadCrumb
              breadCrumbText={breadcrumbText}
              bottom={true}
              displayName={title}
            />

            {/* -------- form section ----------- */}
            <div className="mt-3 p-3 p-lg-4 border border-gray-300 rounded-10 shadow-sm">
              {isDetailsLoading ? (
                <div className="placeholder-glow">
                  {/* Basic Info */}
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-3 d-block rounded"></span>
                    <div className="row">
                      <div className="col-lg-4 mb-3">
                        <span className="placeholder col-3 mb-2 d-block rounded"></span>
                        <span
                          className="placeholder col-12 rounded"
                          style={{ height: "38px" }}
                        ></span>
                      </div>
                      <div className="col-lg-4 mb-3">
                        <span className="placeholder col-3 mb-2 d-block rounded"></span>
                        <span
                          className="placeholder col-12 rounded"
                          style={{ height: "38px" }}
                        ></span>
                      </div>
                      <div className="col-lg-4 mb-3">
                        <span className="placeholder col-3 mb-2 d-block rounded"></span>
                        <span
                          className="placeholder col-12 rounded"
                          style={{ height: "38px" }}
                        ></span>
                      </div>
                    </div>
                  </div>

                  {/* Title */}
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-2 d-block rounded"></span>
                    <span
                      className="placeholder col-12 rounded"
                      style={{ height: "38px" }}
                    ></span>
                  </div>

                  {/* Summary */}
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-2 d-block rounded"></span>
                    <span
                      className="placeholder col-12 rounded"
                      style={{ height: "100px" }}
                    ></span>
                  </div>

                  {/* Details / Editor */}
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-2 d-block rounded"></span>
                    <span
                      className="placeholder col-12 rounded"
                      style={{ height: "300px" }}
                    ></span>
                  </div>

                  {/* Category & Skills */}
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-2 d-block rounded"></span>
                    <span
                      className="placeholder col-12 rounded"
                      style={{ height: "38px" }}
                    ></span>
                  </div>
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-2 d-block rounded"></span>
                    <span
                      className="placeholder col-12 rounded"
                      style={{ height: "38px" }}
                    ></span>
                  </div>

                  {/* Sample Content Table */}
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-3 d-block rounded"></span>
                    <span
                      className="placeholder col-12 rounded"
                      style={{ height: "80px" }}
                    ></span>
                  </div>

                  {/* Authors Bio */}
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-2 d-block rounded"></span>
                    <span
                      className="placeholder col-12 rounded"
                      style={{ height: "100px" }}
                    ></span>
                  </div>

                  {/* Joining & Thanks Message */}
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-2 d-block rounded"></span>
                    <span
                      className="placeholder col-12 rounded"
                      style={{ height: "100px" }}
                    ></span>
                  </div>
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-2 d-block rounded"></span>
                    <span
                      className="placeholder col-12 rounded"
                      style={{ height: "100px" }}
                    ></span>
                  </div>

                  {/* Banner */}
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-2 d-block rounded"></span>
                    <span
                      className="placeholder col-12 rounded"
                      style={{ height: "120px" }}
                    ></span>
                  </div>

                  {/* Privacy Settings */}
                  <div className="mb-4 p-3 border rounded-8">
                    <span className="placeholder col-2 mb-3 d-block rounded"></span>
                    <span
                      className="placeholder col-4 rounded"
                      style={{ height: "24px" }}
                    ></span>
                  </div>
                </div>
              ) : (
                <form onSubmit={(e) => e.preventDefault()}>
                  {/* Basic Info Section */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <h5 className="mb-3">{t("Basic Info")}</h5>
                    {/* <!-- ========== Start code and language Section ========== --> */}
                    <div className="row">
                      <div className="col-lg-4 mb-3 mb-sm-4 mb-lg-0">
                        <label
                          htmlFor="code"
                          className="d-block fs-sm fw-semibold mb-2"
                        >
                          {t("Code")}
                        </label>
                        <input
                          type="text"
                          placeholder={t("e.g., CS101")}
                          id="code"
                          className={`form-control fs-sm shadow-none ${
                            errors.code
                              ? "is-invalid"
                              : "border border-gray-300"
                          }`}
                          value={code}
                          onChange={(e) => {
                            setcode(e.target.value);
                            if (errors.code) {
                              setErrors((prev) => ({ ...prev, code: "" }));
                            }
                          }}
                        />
                        {errors.code && (
                          <div className="invalid-feedback fs-md">
                            {errors.code}
                          </div>
                        )}
                      </div>
                      <div className="col-lg-4">
                        <label
                          htmlFor="language"
                          className="d-block fs-sm fw-semibold mb-2"
                        >
                          {t("Language")}
                        </label>
                        <Select
                          styles={reactSelectStyle("3px", "6px", true, false)}
                          placeholder={t("e.g., English, Spanish")}
                          options={languageOptions}
                          value={languageValue}
                          onChange={(val) => {
                            languaSelectionHandler(val);
                          }}
                        />
                      </div>
                      <div className="col-lg-4">
                        <label
                          htmlFor="parentCourse"
                          className="d-block fs-sm fw-semibold mb-2"
                        >
                          {t("Select Parent")}
                        </label>
                        <Select
                          id="parentCourse"
                          isClearable
                          styles={reactSelectStyle("3px", "6px", true, false)}
                          options={parentCourseList}
                          placeholder={t("Search if this is a sub-course")}
                          value={parentValue}
                          onChange={(val) => {
                            parentCourseSelectionHandler(val);
                          }}
                          onInputChange={(val) => {
                            setparentCourseInput(val);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* <!-- ========== End code and language Section ========== --> */}

                  {/* <!-- ========== Start title Section ========== --> */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="title"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Title")} <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="title"
                      placeholder={t(
                        "e.g., Introduction to React for Beginners",
                      )}
                      className={`form-control fs-sm shadow-none ${
                        errors.title ? "is-invalid" : "border border-gray-300"
                      }`}
                      value={title}
                      onChange={(e) => {
                        settitle(e.target.value);
                        if (errors.title) {
                          setErrors((prev) => ({ ...prev, title: "" }));
                        }
                      }}
                    />
                    {errors.title && (
                      <div className="invalid-feedback fs-md">
                        {errors.title}
                      </div>
                    )}
                  </div>
                  {/* <!-- ========== End title Section ========== --> */}

                  {/* <!-- ========== Start summary Section ========== --> */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="summary"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Summary")}
                    </label>
                    <textarea
                      name="summary"
                      id="summary"
                      cols="30"
                      rows="5"
                      placeholder={t(
                        "Write a short, engaging summary that describes the course.",
                      )}
                      className="form-control fs-sm shadow-none border border-gray-300"
                      value={summary}
                      onChange={(e) => {
                        setsummary(e.target.value);
                      }}
                    ></textarea>
                  </div>
                  {/* <!-- ========== End summary Section ========== --> */}

                  {/* <!-- ========== Start details Section ========== --> */}
                  <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="details"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Details")}
                    </label>
                    <JoditEditor
                      ref={editor}
                      value={details}
                      config={editorConfig}
                      onBlur={(newContent) => {
                        setdetails(newContent);
                      }}
                      onChange={(newContent, event) => {}}
                    />
                  </div>
                  {/* <!-- ========== End details Section ========== --> */}

                  {/* ----- category section start ----- */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="category"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Category")}
                    </label>
                    <Select
                      isMulti
                      styles={categoryCustomStyles}
                      name="selectedCategories"
                      placeholder={t("e.g., Technology, Business, Marketing")}
                      options={categoryList}
                      value={categoryValue}
                      onChange={(val) => {
                        categorySelectionHandler(val);
                        if (errors.selectedCategories) {
                          setErrors((prev) => ({
                            ...prev,
                            selectedCategories: "",
                          }));
                        }
                      }}
                    />
                    {errors.selectedCategories && (
                      <div className="invalid-feedback fs-md">
                        {errors.selectedCategories}
                      </div>
                    )}
                  </div>
                  {/* ----- category section end ----- */}

                  {/* <!-- ========== Start skills Section ========== --> */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="skills"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Skills")}
                    </label>
                    <Select
                      isMulti
                      styles={skillCustomStyles}
                      name="selectedSkills"
                      placeholder={t(
                        "e.g., React, JavaScript, Project Management",
                      )}
                      options={skillList}
                      value={skillValue}
                      onChange={(val) => {
                        skillSelectionHandler(val);
                        if (errors.selectedSkills) {
                          setErrors((prev) => ({
                            ...prev,
                            selectedSkills: "",
                          }));
                        }
                      }}
                    />
                    {errors.selectedSkills && (
                      <div className="invalid-feedback fs-md">
                        {errors.selectedSkills}
                      </div>
                    )}
                  </div>
                  {/* <!-- ========== End skills Section ========== --> */}

                  {/* <!-- ========== Start uploaded files Section ========== --> */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <h5 className="mb-3">{t("Sample Content")}</h5>
                    <div className="table-wrapper">
                      <div className="table-responsive mb-4">
                        <table className="table align-middle fs-sm text-nowrap border-0 mb-0">
                          <thead>
                            <tr>
                              <th className="course-name bg-transparent fs-md fw-semibold border-0">
                                Rank
                              </th>
                              <th className="assignments bg-transparent fs-md fw-semibold border-0">
                                Title
                              </th>
                              <th className="duration-min bg-transparent fs-md fw-semibold border-0">
                                File
                              </th>
                              <th
                                className="questions bg-transparent fs-md fw-semibold border-0"
                                style={{ width: "40%" }}
                              >
                                Description
                              </th>
                              <th className="action bg-transparent fs-md fw-semibold border-0">
                                Action
                              </th>
                            </tr>
                          </thead>
                          {uploadedFiles.length === 0 ? null : (
                            <tbody>
                              {uploadedFiles
                                ?.sort((a, b) => a.rank - b.rank)
                                ?.map((content, index) => {
                                  return (
                                    <tr key={index}>
                                      <td className="course-name border-bottom-0">
                                        <div className="d-flex align-items-center gap-4">
                                          <p>{content.rank}</p>
                                        </div>
                                      </td>
                                      <td className="assignments border-bottom-0">
                                        <p>{content.title}</p>
                                      </td>
                                      <td className="questions border-bottom-0">
                                        <p className="mb-0">{content.name}</p>
                                      </td>

                                      <td className="created border-bottom-0">
                                        <p>{content.description}</p>
                                      </td>
                                      <td className="action border-bottom-0">
                                        <div className="d-flex align-items-center gap-2">
                                          <Link
                                            to="#"
                                            className="d-flex align-items-center gap-1 fs-md fw-semibold text-primary"
                                            data-bs-toggle="modal"
                                            data-bs-target="#upload_content"
                                            onClick={() => {
                                              setSelectedUploadId(content._id);
                                            }}
                                          >
                                            <span className="d-block material-symbols-outlined">
                                              edit
                                            </span>
                                          </Link>
                                          <button
                                            className="d-flex align-items-center gap-1 fs-md fw-semibold text-primary border-0"
                                            data-bs-toggle="modal"
                                            data-bs-target="#deletewarning"
                                            onClick={() => {
                                              //set states for delete
                                              setcontetnIdForDelete(
                                                content._id,
                                              );
                                              setcontentIndexForDelete(index);
                                            }}
                                            disabled={isDeleting ? true : false}
                                            style={{
                                              cursor: isDeleting
                                                ? "not-allowed"
                                                : "pointer",
                                            }}
                                          >
                                            {isDeleting &&
                                            contentIndexForDelete === index ? (
                                              <div
                                                className="mx-2 spinner-border spinner-border-sm"
                                                role="status"
                                              >
                                                <span className="visually-hidden">
                                                  Loading...
                                                </span>
                                              </div>
                                            ) : (
                                              <span className="d-block material-symbols-outlined">
                                                delete
                                              </span>
                                            )}
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          )}
                        </table>
                      </div>
                      <div className="add_another">
                        <Link
                          to="#"
                          data-bs-toggle="modal"
                          data-bs-target="#upload_content"
                          className="btn btn-outline-primary"
                        >
                          Add Content
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* <!-- ========== End uploaded files Section ========== --> */}

                  {/* <!-- ========== Start authors bio Section ========== --> */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="Authors"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Authors Bio")}
                    </label>
                    <textarea
                      name="summary"
                      id="Authors"
                      cols="30"
                      rows="5"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder={t(
                        "Tell us about the instructor(s). Include their experience and qualifications.",
                      )}
                      value={authorsBio}
                      onChange={(e) => {
                        setauthorsBio(e.target.value);
                      }}
                    ></textarea>
                  </div>
                  {/* <!-- ========== End authors bio Section ========== --> */}

                  {/* <!-- ========== Start joining message Section ========== --> */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="joinmessage"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Joining Message")}
                    </label>
                    <textarea
                      name="summary"
                      id="joinmessage"
                      cols="30"
                      rows="5"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder={t(
                        "e.g., Welcome to the course! We're excited to have you join us.",
                      )}
                      value={joinMessage}
                      onChange={(e) => {
                        setjoinMessage(e.target.value);
                      }}
                    ></textarea>
                  </div>
                  {/* <!-- ========== End joining message Section ========== --> */}

                  {/* <!-- ========== Start thanks message Section ========== --> */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="thanksmessage"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Thanks Message")}
                    </label>
                    <textarea
                      name="summary"
                      id="thanksmessage"
                      cols="30"
                      rows="5"
                      className="form-control fs-sm shadow-none border border-gray-300"
                      placeholder={t(
                        "e.g., Congratulations on completing the course! We hope you enjoyed it.",
                      )}
                      value={thanksMessage}
                      onChange={(e) => {
                        setthanksMessage(e.target.value);
                      }}
                    ></textarea>
                  </div>
                  {/* <!-- ========== End thanks message Section ========== --> */}

                  {/* <!-- ========== Start banner Section ========== --> */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <label
                      htmlFor="banner"
                      className="d-block fs-sm fw-semibold mb-2"
                    >
                      {t("Course Banner")}
                    </label>
                    <FileUploadField
                      label={t("Banner")}
                      accept="jpg png jpeg"
                      onUpload={imageUploadHandler}
                      files={
                        uploadedPreviewImage === ""
                          ? [
                              {
                                path: "https://placehold.co/150x150",
                                name: "Course Banner",
                              },
                            ]
                          : [
                              {
                                path: url.SERVER_URL + uploadedPreviewImage,
                                name: "Course Banner",
                              },
                            ]
                      }
                      onRemove={() => {
                        setUploadedPreviewImage("");
                        setUploadedImageId(null);
                      }}
                      loading={isUploading}
                      fileType="image"
                    />
                  </div>
                  {/* <!-- ========== End banner Section ========== --> */}

                  {/* ----- auto accept section start ----- */}
                  <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                    <h5 className="mb-3">{t("Privacy Settings")}</h5>
                    <div className="form-check d-flex align-items-center gap-2 fs-sm p-0 m-0 mb-3">
                      <input
                        className="form-check-input bg-transparent border-2 border-gray-600 shadow-none m-0"
                        type="checkbox"
                        checked={autoAccept}
                        onChange={(e) => setautoAccept(e.target.checked)}
                        id="autoaccept"
                      />
                      <label className="form-check-label" htmlFor="autoaccept">
                        {t("Auto accept joining invitations")}
                      </label>
                    </div>
                  </div>

                  {/* ----- auto accept section end ----- */}

                  {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                      {errorMessage}
                    </div>
                  )}
                </form>
              )}
            </div>
          </div>
        </section>
        {/* Fixed Footer */}
        <div className="fixed-bottom bg-white border-top shadow-lg py-3">
          <div className="container-fluid px-lg-5">
            <div className="d-flex justify-content-between align-items-center">
              <Link
                to="/admin/courses"
                className="btn btn-outline-primary px-4 d-flex align-items-center"
              >
                <span className="material-symbols-outlined align-middle me-1">
                  cancel
                </span>
                {t("Cancel")}
              </Link>
              <div className="d-flex gap-2">
                {/* Scroll to Top Button */}
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  title={t("Scroll to Top")}
                >
                  <span className="material-symbols-outlined">
                    keyboard_arrow_up
                  </span>
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-4"
                  onClick={saveCourseHandler}
                  style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
                  disabled={isSaving}
                >
                  <span className="material-symbols-outlined align-middle me-1">
                    save
                  </span>
                  {params.id ? t("Update Course") : t("Save Course")}
                  {isSaving && (
                    <div
                      className="mx-2 spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* ======== popups and modal section =========== */}

        {/* ------- Upload Content Modal ------ */}
        <UploadContentModal
          selectedUploadId={selectedUploadId}
          setSelectedUploadId={setSelectedUploadId}
          uploadedFiles={uploadedFiles}
          setuploadedFiles={setuploadedFiles}
          uploadedFileIds={uploadedFileIds}
          setuploadedFileIds={setuploadedFileIds}
          setShowAlert={setShowAlert}
          setMessageType={setMessageType}
          setAlertMessage={setAlertMessage}
        />

        {/* ------- After Save Course Modal ------ */}
        <AfterSaveCourseModal
          afterSaveCourseModalClose={afterSaveCourseModalClose}
        />

        {/* ----------- delete warning modal ------------ */}
        <DeleteWarningModal
          onCancelDelete={() => {
            setcontentIndexForDelete(null);
            setcontetnIdForDelete(null);
          }}
          onDelete={deleteContentHandler}
          moduleName={t("content")}
        />
        {/* ------- Alert Notification ------ */}
        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default CourseDetailBody;
